import {FC} from "react";
import StarIconActive from "../../../assets/icons/icon-star-active.svg";
import {SnippetShowThreeIcons} from "./SnippetShowThreeIcons";

interface IProps {
  priority: "Высокий" | "Средний" | "Низкий";
  title?: string;
  size?: "xs" | "sm" | "md" | "lg";
}

export const BlockWithStars: FC<IProps> = ({priority, title, size = "sm"}) => {
  const countActiveStatus =
    priority === "Высокий" ? 3 : priority === "Средний" ? 2 : 1;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: title ? "space-between" : "start",
        gap: 20,
      }}
    >
      {title && <div style={{color: "#fff", fontSize: 15}}>{title}</div>}
      <div style={{color: "#fff", fontSize: 14}} id={"priority-stars"}>
        <SnippetShowThreeIcons
          countActive={countActiveStatus}
          imgActive={StarIconActive}
          id="priority-stars"
          tooltip=""
          size={size}
        />
      </div>
    </div>
  );
};
